import Link from '@/components/Link/Link';
import { useRegister } from '@/hooks/card/useRegister';
import { failedPaymentStatuses } from '@/utils/constants';
import ErrorIcon from '@mui/icons-material/Error';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CardError = () => {
  const { t } = useTranslation();
  const { paymentSession, queryErrorPaymentSession, queryErrorAni, ani, resetRegistrationCode, resetPaymentSession } =
    useRegister();

  useEffect(() => {
    if (queryErrorPaymentSession) {
      resetPaymentSession();
    }

    if (queryErrorAni || (ani && ani.status?.toLowerCase() === 'error') || (ani && ani.status?.toLowerCase() === 'expired')) {
      resetRegistrationCode();
    }
  }, [queryErrorPaymentSession, queryErrorAni, ani]);

  return !!paymentSession && failedPaymentStatuses.includes(paymentSession?.payment?.status?.toLowerCase()) ? (
    <Stack gap={4} alignItems='center' justifyContent='center'>
      <Typography variant='body1' fontWeight='bold'>
        {t('page.card.error-step.card-could-not-be-connected')}
      </Typography>

      <ErrorIcon color='error' sx={{ fontSize: 64 }} />

      <Typography variant='body2'>
        {t('page.card.error-step.connect-card-here')}{' '}
        <Link href='/card' color='inherit'>
          {t('common-phrases.click-here')}
        </Link>
      </Typography>
    </Stack>
  ) : (
    <Stack gap={4} alignItems='center' justifyContent='center'>
      <Typography variant='body1' fontWeight='bold'>
        {t('page.card.error-step.invalid-link')}
      </Typography>

      <ErrorIcon color='error' sx={{ fontSize: 64 }} />

      <Typography variant='body2'>{t('page.card.error-step.invalid-link-desc')} </Typography>

      <Typography variant='body2'>
        {t('page.card.error-step.connect-card-here')}{' '}
        <Link href='/card' color='inherit'>
          {t('common-phrases.click-here')}
        </Link>
      </Typography>
    </Stack>
  );
};

export default CardError;
